export function querySelectorURLBase(query, url) {
    let value = new URL(url).searchParams.get(query);
    switch (value) {
        case "": // empty string
            value = true;
            break;
        case null: // doesn't exist
            value = false;
            break;
        default:
            // keep value
            break;
    }
    return value;
}
export function querySelectorURL(query) {
    return querySelectorURLBase(query, window.location.href);
}
